module.exports = __webpack_public_path__ + "img/equipamiento.82e5bf8b.jpg";